export enum NoticeType {

    AdminNoticeType ='ADMIN',
    EmployeeAdmin ='EmployeeAdmin'
}